/**
 * Created by maciej on 22/06/2016.
 */
import {app} from '../app';

export interface IThemerService {
    setDefaults();
    getSelectors():ISelector[];
    setSelectors(selectors: ISelector[]);
    getSelector(name:string):ISelector;
    onChange(callback: () => void): () => void;
}

export class ThemerService implements IThemerService {

    private defaultSelectors:ISelector[] = [
        {
            selector: 'button',
            declarations: [
                {
                    property: 'background-color',
                    value: '#5bc0de'
                },
                {
                    property: 'border-color',
                    value: '#44b3d4'
                }
            ]
        },
        {
            selector: 'button',
            state: 'hover',
            declarations: [
                {
                    property: 'background-color',
                    value: '#31b0d5'
                },
                {
                    property: 'border-color',
                    value: '#269abc'
                }
            ]
        },
        {
            selector: 'button',
            state: 'active',
            declarations: [
                {
                    property: 'background-color',
                    value: '#31b0d5'
                },
                {
                    property: 'border-color',
                    value: '#269abc'
                }
            ]
        },
        {
            selector: 'button',
            state: 'focus',
            declarations: [
                {
                    property: 'background-color',
                    value: '#31b0d5'
                },
                {
                    property: 'border-color',
                    value: '#269abc'
                }
            ]
        },
        {
            selector: 'link',
            declarations: [
                {
                    property: 'color',
                    value: '#337ab7'
                }
            ]
        },
        {
            selector: 'link',
            state: 'hover',
            declarations: [
                {
                    property: 'color',
                    value: '#23527c'
                }
            ]
        },
        {
            selector: 'likertRadio',
            declarations: [
                {
                    property: 'background-color',
                    value: '#5bc0de'
                }
            ]
        },
        {
            selector: 'progressFirst',
            declarations: [
                {
                    property: 'background-color',
                    value: '#5bc0de'
                }
            ]
        },
        {
            selector: 'progressSecond',
            declarations: [
                {
                    property: 'background-color',
                    value: '#f0ad4e'
                }
            ]
        },
    ];
    private onChangeCallbacks: (() => void)[] = [];

    private selectors:ISelector[];

    constructor() {
        this.setDefaults();
    }

    setDefaults() {
        this.setSelectors(angular.copy(this.defaultSelectors));
    }

    getSelectors():ISelector[] {
        return this.selectors;
    }

    setSelectors(selectors: ISelector[]) {
        this.selectors = this.selectors ? ThemerService.mergeSelectors(this.selectors, selectors) : selectors;
        this.onChangeCallbacks.forEach(callback => callback());
    }

    private static mergeSelectors(a: ISelector[], b: ISelector[]):ISelector[] {
        for (let aSelector of a) {
            for (let bSelector of b) {
                if (aSelector.selector === bSelector.selector && aSelector.state === bSelector.state) {
                    aSelector.declarations = ThemerService.mergeDeclarations(aSelector.declarations, bSelector.declarations);
                    break;
                }
            }
        }

        return a;
    }

    private static mergeDeclarations(a: ISelectorDeclaration[], b: ISelectorDeclaration[]):ISelectorDeclaration[] {
        for (let aDeclaration of a) {
            for (let bDeclaration of b) {
                if (aDeclaration.property === bDeclaration.property) {
                    aDeclaration.value = bDeclaration.value;
                    break;
                }
            }
        }

        return a;
    }

    getSelector(name:string):ISelector {
        for (let selector of this.selectors) {
            if (selector.selector === name) {
                return selector;
            }
        }

        return null;
    }

    onChange(callback: () => void): () => void {
        let index = this.onChangeCallbacks.push(callback) - 1;

        return () => {
            this.onChangeCallbacks.splice(index, 1);
        };
    }

    static factory() {
        const factory = () => new this();
        factory.$inject = [];
        return factory;
    }

}

app.factory('ThemerService', ThemerService.factory());